import { Reducer, Action } from "redux";
import { ISecurityAssesmentState, SecurityAssesmentTypes, REQUEST_SECURITY_ASSESSMENT_DATA, RECEIVE_SECURITY_ASSESSMENT_DATA } from "./types";

export const securityAssesmentReducer: Reducer<ISecurityAssesmentState> = (
    state: ISecurityAssesmentState | undefined,
    incomingAction: Action
): ISecurityAssesmentState => {
    if (state === undefined) {
        return { assessmentData: undefined, isLoading: false };
    }

    const action = incomingAction as SecurityAssesmentTypes;
    switch (action.type) {
        case RECEIVE_SECURITY_ASSESSMENT_DATA:
            return {
                isLoading: false,
                assessmentData: action.assessmentData,
            };
        case REQUEST_SECURITY_ASSESSMENT_DATA:
            return {
                isLoading: true,
                assessmentData: state.assessmentData,
            };
        default:
            return state;
    }
};
